import React from 'react'
import {Box, Text} from '@chakra-ui/react';
import Container from "../../../components/Container";
import {MarqueeSpring} from "../../../components/Marquee/MarqueeSpring";

const SlideShow = ({data}) => {

    return (
        <Box borderX={'1px'} borderColor={'brandAlpha.200'} as="section">
            <Box px={['2.5', '5']}>
                <Container>
                    <Box pb={'50px'}>
                        <MarqueeSpring children={data?.acf?.carousel_items} data={data} />
                    </Box>
                </Container>
            </Box>
        </Box>
    );
};
export default SlideShow;
